<div *ngIf="visible" id="sensor_point_popup" class="popup-content">
  <div *ngFor="let key of getKeys()">
    <button *ngIf="classifyButtonVisible" class="apply-format-button" (click)="classify(key)">
      <kendo-svg-icon [icon]="ApKendoIconService.Get('grayscaleIcon')"></kendo-svg-icon>
    </button>
    {{key}}: {{valueMap[key]}}
  </div>
</div>
